import { render, staticRenderFns } from "./WhatsappTemplateGuide.vue?vue&type=template&id=76ca1b2d&scoped=true&"
import script from "./WhatsappTemplateGuide.vue?vue&type=script&lang=js&"
export * from "./WhatsappTemplateGuide.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappTemplateGuide.vue?vue&type=style&index=0&id=76ca1b2d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ca1b2d",
  null
  
)

export default component.exports